import { Box, CircularProgress, Tooltip, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Iconify from '../../../fl-components/Iconify';
import palette from '../../../theme/palette';
import { ansMCQ } from '../../../service/feed.service';
import { UPDATE_FEED } from '../../../redux/constants';

export default function MCQContainer({ post }) {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectedOpId, setSelectedOpId] = useState('');

  const isAnsGiven = useMemo(() => {
    // If user has given ans
    if (post?.mcqOptions.filter((op) => op.interactedUsers.includes(currentUser.id)).length > 0) {
      return true;
    }

    return false;
  }, [post]);

  const updateAns = async (optionId) => {
    setLoading(true);
    setSelectedOpId(optionId);
    // do api call
    const res = await ansMCQ(post?.id ?? post?._id, currentUser.id, optionId);
    if (res) {
      dispatch({
        type: UPDATE_FEED,
        payload: {
          isUpdateOrg: true,
          feedObj: res
        }
      });
      setLoading(false);
      setSelectedOpId('');
    } else {
      setLoading(false);
      setSelectedOpId('');
    }
  };

  return (
    <>
      {post.mcqOptions.map((po) => (
        <Box
          key={po._id}
          sx={{
            textAlign: isAnsGiven ? 'unset' : 'center',
            p: 1,
            fontWeight: 'bold',
            marginTop: '8px !important',
            position: 'relative',
            border: `1px solid ${palette.grey[300]}`,
            borderRadius: !isAnsGiven ? 4 : '8px',
            ...(!isAnsGiven && {
              '&:hover': {
                cursor: 'pointer',
                background: palette.grey[200]
              }
            }),
            ...(isAnsGiven && {
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            })
          }}
          onClick={isAnsGiven || loading ? () => {} : () => updateAns(po._id)}
        >
          <Typography
            sx={{
              zIndex: 1,
              display: 'flex',
              fontWeight: isAnsGiven ? 'normal' : 'bold',
              ...(isAnsGiven && {
                alignItems: 'center'
              }),
              ...(!isAnsGiven && {
                justifyContent: 'center'
              })
            }}
          >
            {po.value}
            {loading && selectedOpId === po._id && (
              <CircularProgress color="inherit" size={15} sx={{ ml: 1 }} />
            )}
          </Typography>
          {isAnsGiven && (
            <>
              {po.interactedUsers.includes(currentUser.id) && !po.isAnswer && (
                <Tooltip title="Your selected answer" placement="top">
                  <Box display="flex">
                    <Iconify
                      icon="ep:circle-close-filled"
                      width={20}
                      height={20}
                      sx={{ color: '#d30000' }}
                    />
                  </Box>
                </Tooltip>
              )}
              {po.isAnswer && (
                <Tooltip title="Correct answer" placement="top">
                  <Box display="flex">
                    <Iconify
                      icon="bi:check-circle-fill"
                      width={18}
                      height={18}
                      sx={{ color: '#00d383' }}
                    />
                  </Box>
                </Tooltip>
              )}
            </>
          )}
        </Box>
      ))}
    </>
  );
}

MCQContainer.propTypes = {
  post: PropTypes.object
};
